import { defineStore } from "pinia";
import { computed } from "vue";
import { useSessionStorage } from "@vueuse/core";

import { UserListResponse, UserResponse } from "src/generated/formeapi";
import { AppendixType } from "stores/useKidStore";
import useFormeServer from "src/composables/server/useFormeServer";
import { isString } from "src/types/typeGuard";
import { date } from "quasar";
import useConst from "src/composables/useConst";
import useTime from "src/composables/useTime";

export type TKid = Omit<UserResponse, "appendix"> & {
  appendix: AppendixType;
  usePeriod: number;
};
export const useKidsStore = defineStore("kids", () => {
  const kids = useSessionStorage(
    `forme_b2c_${process.env.VUE_APP_ENV}/kids`,
    [] as TKid[]
  );

  const getKids = computed((): TKid[] => {
    return kids.value;
  });

  const { todayTS } = useTime();

  // 뽀미 사용 기간 계산
  function calcUsePeriod(planStartDT?: string): number {
    if (!planStartDT) {
      return 0;
    }
    const diff = date.getDateDiff(planStartDT, todayTS(), "days");
    if (diff > 0) return 0;
    if (diff === 0) return 1;
    else return -(diff - 1);
  }

  function setKids(kidsData: UserResponse[]) {
    kids.value = kidsData
      ?.sort((a, b) => (b.CTS ?? 0) - (a.CTS ?? 0))
      .map((kid) => {
        const appendix: AppendixType = JSON.parse(kid.appendix);
        const usePeriod = calcUsePeriod(kid.planStartDT);
        return {
          ...kid,
          appendix,
          usePeriod,
        };
      });
  }

  const formeServer = useFormeServer();

  const { model } = useConst();

  async function fetchKidList(): Promise<UserListResponse | undefined> {
    try {
      const data = await formeServer.v2ResourcesListUser(model);
      if (isString(data)) {
        console.error(data, "kidsStore");
        return;
      }

      console.log("kidsStore", data);

      if (!data.users.length) {
        console.error("조회된 자녀가 없습니다.", "kidsStore");
        return;
      }

      return data;
    } catch (e) {
      console.error(e + "", "kidsStore");
    }
  }

  async function reFetchKids() {
    const data = await fetchKidList();
    if (!data) {
      resetKids();
      return;
    }
    setKids(data.users);
  }

  function resetKids() {
    kids.value = [] as TKid[];
  }

  return {
    kids,
    getKids,
    setKids,
    resetKids,
    reFetchKids,
  };
});
